import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useControlPanelBranding } from '../context/control-panel/ControlPanelBrandingContext';

const AdminDocumentHead = () => {
  const { name } = useControlPanelBranding();

  return (
    <Helmet>
      <title>{name}</title>
      <meta name="robots" content="noindex, nofollow, noarchive, nosnippet" />
      <meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet" />
      <meta name="description" content={name} />
    </Helmet>
  );
};

export default AdminDocumentHead;
